import React, { useState } from 'react';
import { ASSET_URL } from '../../../../helper/api_url';
import { getTrialStatus, getStatusBadge, openGoogleMap, truncateText } from '../EnquiryList/enquiryUtils';
import { AddressModal } from '../EnquiryList/AddressModal';

export const CallLogSchoolCell = ({ row, handleReport }) => {
    const [showAddressModal, setShowAddressModal] = useState(false);

    const enquiry = row.enquiry || {};
    const imageUrl = ASSET_URL + enquiry.avatar;
    const trialStatus = getTrialStatus(enquiry.tryal_date, enquiry.tryal_period);
    const status = getStatusBadge(row.status || enquiry.status);
    const address = enquiry.address_1 || enquiry.address || '';
    const truncated = truncateText(address, 28);

    return (
        <div className="d-flex align-items-center gap-2 py-1">
            {/* Avatar with Status Indicator Bubble */}
            <div className="avatar-status-wrapper flex-shrink-0">
                <img
                    className="rounded-circle border"
                    style={{ width: '38px', height: '38px', objectFit: 'cover' }}
                    src={imageUrl}
                    alt={enquiry.name || 'School Avatar'}
                />
                <span
                    className={`status-bubble status-bubble-${status.color}`}
                    title={`Status: ${status.label}`}
                />
            </div>

            {/* School Details */}
            <div style={{ minWidth: 0 }}>
                {/* School Name & Trial Status */}
                <div className="d-flex align-items-center gap-1.5 flex-wrap">
                    <span
                        role="button"
                        onClick={() => handleReport && handleReport(row)}
                        className="fw-semibold text-dark fs-13 text-truncate d-inline-block school-name-link cursor-pointer"
                        style={{ maxWidth: '220px', cursor: 'pointer' }}
                        title={`Click to view history report for ${enquiry.name || 'School'}`}
                    >
                        {enquiry.name || 'Candidate / School'}
                    </span>
                    {trialStatus && (
                        <span className={`badge ${trialStatus.badgeClass} fs-11 px-2 py-0.5`}>
                            {trialStatus.label}
                        </span>
                    )}
                </div>

                {/* Truncated Address */}
                <div className="fs-12 text-muted lh-sm text-truncate mt-0.5" style={{ maxWidth: '240px' }}>
                    {address ? (
                        <span>
                            {truncated.displayText}
                            {truncated.isTruncated && (
                                <span
                                    className="badge bg-soft-primary text-primary ms-1 cursor-pointer address-dot-trigger"
                                    onClick={() => setShowAddressModal(true)}
                                    title="Click to view full address"
                                >
                                    ...
                                </span>
                            )}
                        </span>
                    ) : (
                        <span className="fst-italic text-muted">No address</span>
                    )}
                </div>

                {/* District & Map Pin Icon */}
                <div className="d-flex align-items-center gap-2 mt-0.5">
                    <span className="text-secondary fs-11 d-inline-flex align-items-center gap-1">
                        <i className="ri-building-line text-muted fs-11" />
                        <span>{enquiry.district || 'District N/A'}</span>
                    </span>
                    {enquiry.feedback && (
                        <button
                            type="button"
                            className="btn btn-sm btn-link text-danger p-0 map-pin-icon-btn"
                            onClick={() => openGoogleMap(enquiry.feedback)}
                            title="Open Google Map"
                        >
                            <i className="ri-map-pin-2-fill fs-12" />
                        </button>
                    )}
                </div>
            </div>

            {/* Address Modal */}
            {showAddressModal && (
                <AddressModal
                    show={showAddressModal}
                    onHide={() => setShowAddressModal(false)}
                    schoolName={enquiry.name}
                    address={address}
                    district={enquiry.district}
                    mapUrl={enquiry.feedback}
                />
            )}
        </div>
    );
};

export default CallLogSchoolCell;
